import PropTypes from 'prop-types';
import Listing from './listing';
import Address from './address';
import Property from './property';
import Agency from './agency';
export default {
  listing: PropTypes.shape(Listing),
  address: PropTypes.shape(Address),
  property: PropTypes.shape(Property),
  agency: PropTypes.shape(Agency)
};